import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue';
import { DepreciationMaterialRecord, Warehouse } from '@/types/Component';
import { toCamel } from 'snake-camel';

type Material = {
    itemId: string
    displayName: string;
    type: string;
    warehouseId: string;
    warehouseName: string;
}

@Component({
    components: {
        Modal
    }
})
export default class SelectDeprecationMaterials extends Vue {
    private baseUrl = '/warehouses'
    private warehouses: Warehouse[] = []
    private initialWarehouse: Warehouse = {
        id: "",
        name: "",
        chemicals: [],
        fertilizers: [],
        depreciationMaterials: [],
        expendableMaterials: [],
        isHidden: false
    }
    private selectedWarehouse: Warehouse = this.initialWarehouse
    private displayMaterials: { itemId: string; displayName: string; type: string; }[] = []
    private selectedMaterials: Material[] = []
    private searchWord = ""
    private displayWarehouses: Warehouse[] = []

    @Prop()
    private value!: boolean

    @Prop({
        required: true
    })
    private preSelectItem!: DepreciationMaterialRecord[]

    @Emit('input')
    private input(value: boolean) {
        value
    }

    @Emit('close')
    private save() {
        return this.selectedMaterials.map(material => ({
            warehouseId: material.warehouseId,
            warehouseName: material.warehouseName,
            itemId: material.itemId,
            displayName: material.displayName,
            type: material.type
        }))
    }

    @Emit('cancel')
    private cancel() {
        // 初期化処理
        this.searchWord = ""
        this.displayMaterials = []
        this.selectedMaterials = []
        this.selectedWarehouse = this.initialWarehouse
    }

    @Watch('value')
    private onOpenModal() {
        if (this.value) {
            this.searchWord = ""
            this.displayMaterials = []
            this.selectedMaterials = []
            this.displayWarehouses = []
            this.selectedWarehouse = this.initialWarehouse
            this.getWarehouses()
        }
    }

    get isModalVisible(): boolean {
        return this.value;
    }

    set isModalVisible(value: boolean) {
        this.input(value);
    }

    private getWarehouses() {
        this.$apiClient.doRequest('get', `${this.baseUrl}?with_hidden=false`).then(ret => {
            this.warehouses = this.displayWarehouses = (toCamel(ret) as { warehouses: Warehouse[] }).warehouses
            .filter(w => w.name?.trim() !== '未管理')// ← remove 未管理 warehouse
            .map(warehouse => ({
                id: warehouse.id,
                name: warehouse.name,
                chemicals: warehouse.chemicals,
                fertilizers: warehouse.fertilizers,
                depreciationMaterials: warehouse.depreciationMaterials.map(material => ({
                    itemId: material.itemId,
                    displayName: material.displayName,
                    type: material.type,
                    warehouseId: warehouse.id,
                    warehouseName: warehouse.name
                })),
                expendableMaterials: warehouse.expendableMaterials,
                isHidden: warehouse.isHidden
            }))
            if (this.preSelectItem?.length) {
                // 渡された農薬を選択済みにする
                this.selectedMaterials = this.preSelectItem.map(item => ({
                    itemId: item.itemId,
                    displayName: item.displayName,
                    type: item.type,
                    warehouseId: item.warehouseId,
                    warehouseName: item.warehouseName
                }))

                // 最初に選択された倉庫を選択状態にする
                this.selectedWarehouse = this.warehouses.find(warehouse => warehouse.id === this.selectedMaterials[0]?.warehouseId) || this.initialWarehouse
                this.displayMaterials = this.selectedWarehouse.depreciationMaterials
            } else {
                // 先頭の倉庫を選択状態にする
                this.selectedWarehouse = this.warehouses[0]
                this.displayMaterials = this.selectedWarehouse.depreciationMaterials
            }
        })
    }

    private selectWarehouse(warehouse: Warehouse) {
        this.selectedWarehouse = warehouse
        this.displayMaterials = warehouse.depreciationMaterials
        this.filteringMaterials()
    }

    private filteringMaterials() {
        this.displayMaterials = this.warehouses.find(warehouse => this.selectedWarehouse.id === warehouse.id)?.depreciationMaterials.filter(material => material.displayName.indexOf(this.searchWord) > -1) || []
    }

    private search() {
        this.displayWarehouses = this.warehouses.filter(warehouse => warehouse.depreciationMaterials.filter(material => material.displayName.indexOf(this.searchWord) > -1).length)
        this.filteringMaterials()
    }
}